import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJCV from './DJCV';
// import DJCVPrint from '../DJCVPrint/DJCVPrint';

//Estilos

function DJCVContainer() {
    const { token, masters, grapesVariety, settings, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [print, setPrint] = useState(false);
    const [WatchDJCVLogs, setWatchDJCVLogs] = useState(false);
    const [DJCVData, setDJCVData] = useState({});

    const Params = useParams();

    useEffect(() => {
        // const getMyDJCV = async () => {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJCV segun el id que esta en los params
        //         const MyDJCVs = await DJCVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         //Si la respuesta es correcta seteamos el estado de DJCVData con los datos de la respuesta
        //         if (MyDJCVs) {
        //             const getNombreUsuario = await UserService.getNombreUsuario(
        //                 { token, usuarioId: MyDJCVs.data.cabecera.usuario }
        //             );
        //             if (getNombreUsuario) {
        //                 setDJCVData({
        //                     ...MyDJCVs.data,
        //                     ...getNombreUsuario.data,
        //                 });
        //             }
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // };
        // getMyDJCV();
    }, [Params.id]);

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJCV
                functions={{
                    formatNumber,
                    setPrint,
                    setWatchDJCVLogs,
                }}
                states={{ WatchDJCVLogs, DJCVData, masters }}
            />
            {/* <DJCVPrint
                        functions={{
                            formatNumber,
                            setPrint,
                        }}
                        states={{
                            DJCVData,
                            masters,
                            grapesVariety,
                            settings,
                        }}
                    /> */}
        </>
    );
}

export default DJCVContainer;
